export default __webpack_public_path__ + "static/media/home-image2.0f314e85.svg";